/*
 * .nomcaché — Judge.me review translations.
 *
 * Add future reviewed translations here only. The renderer is intentionally
 * independent from these records. A null title means Judge.me did not receive
 * a title for that review and must not have one invented in the storefront.
 */
window.__NOMCACHE_JUDGEME_REVIEW_TRANSLATIONS__ = Object.freeze({
  '494c81b6-3a29-448f-967f-f5af2f92dae0': Object.freeze({
  "judgeMeReviewId": null,
  "sourceLocale": "pl",
  "original": {
    "title": null,
    "body": "Żona siedzi mocno w kosmetykach, więc ciężko ją czymś zaskoczyć. Kupiłem trochę w ciemno i miałem obawy, czy jej podejdzie. Balsamem jest zachwycona, więc prezent siadł :)"
  },
  "translations": {
    "en": {
      "title": null,
      "body": "My wife is really into cosmetics, so it’s hard to surprise her with anything. I took a bit of a chance buying this and wasn’t sure whether she’d like it. She loves the balm, so the gift was a hit :)"
    },
    "nl": {
      "title": null,
      "body": "Mijn vrouw is echt gek op cosmetica, dus het is lastig om haar nog ergens mee te verrassen. Ik kocht dit een beetje op goed geluk en twijfelde of het iets voor haar zou zijn. Ze is helemaal weg van de balsem, dus het cadeau was een schot in de roos :)"
    },
    "fr": {
      "title": null,
      "body": "Ma femme s’y connaît vraiment bien en cosmétiques, donc ce n’est pas facile de la surprendre. J’ai acheté un peu à l’aveugle et j’avais peur que ça ne lui plaise pas. Elle adore le baume, donc le cadeau a fait mouche :)"
    },
    "de": {
      "title": null,
      "body": "Meine Frau kennt sich mit Kosmetik wirklich gut aus, daher ist es schwer, sie noch mit etwas zu überraschen. Ich habe ein bisschen auf gut Glück gekauft und war unsicher, ob es ihr gefallen würde. Vom Balsam ist sie begeistert, also war das Geschenk ein Volltreffer :)"
    },
    "it": {
      "title": null,
      "body": "Mia moglie se ne intende davvero di cosmetici, quindi è difficile sorprenderla con qualcosa. L’ho comprato un po’ alla cieca e temevo che potesse non piacerle. Il balsamo le piace tantissimo, quindi il regalo è stato un successo :)"
    }
  }
}),
  'ad87c306-8ce3-4a81-8c4a-49cdda2e83ad': Object.freeze({
    judgeMeReviewId: null,
    sourceLocale: 'pl',
    original: Object.freeze({
      title: null,
      body: 'Dość wysoka cena, ale produkt zdecydowanie broni się zapachem. Pachnie pięknie i długo utrzymuje się na skórze, a sama skóra po użyciu jest naprawdę miękka i przyjemna w dotyku. Do tego całość jest bardzo dopracowana i już samo opakowanie robi duże wrażenie.🙂'
    }),
    translations: Object.freeze({
      en: Object.freeze({
        title: null,
        body: 'The price is quite high, but the fragrance definitely justifies it. It smells beautiful and lasts on the skin for a long time, while the skin is genuinely soft and pleasant to the touch after use. On top of that, everything is very thoughtfully made, and the packaging alone makes a big impression.🙂'
      }),
      nl: Object.freeze({
        title: null,
        body: 'De prijs is best hoog, maar de geur maakt dat absoluut goed. Het ruikt prachtig en blijft lang op de huid hangen, en de huid voelt na gebruik echt zacht en prettig aan. Bovendien is alles heel zorgvuldig uitgewerkt en maakt alleen al de verpakking veel indruk.🙂'
      }),
      fr: Object.freeze({
        title: null,
        body: 'Le prix est assez élevé, mais le parfum le justifie largement. Il sent très bon et tient longtemps sur la peau, tandis que la peau est vraiment douce et agréable au toucher après utilisation. De plus, tout est très soigné et l’emballage à lui seul fait forte impression.🙂'
      }),
      de: Object.freeze({
        title: null,
        body: 'Der Preis ist recht hoch, aber der Duft rechtfertigt ihn eindeutig. Er duftet wunderbar und hält lange auf der Haut, und die Haut ist nach der Anwendung wirklich weich und angenehm. Außerdem ist alles sehr sorgfältig ausgearbeitet, und schon die Verpackung macht einen starken Eindruck.🙂'
      }),
      it: Object.freeze({
        title: null,
        body: 'Prezzo piuttosto alto, ma il prodotto si difende decisamente con la fragranza. Profuma splendidamente e rimane a lungo sulla pelle, mentre la pelle stessa dopo l\'uso è davvero morbida e piacevole al tatto. In più il tutto è molto curato e già la confezione fa una grande impressione. 😅'
      })
    })
  })
});